import React, {Component} from "react";
import "./index.scss";
import {bool, oneOf, string, number, func, oneOfType, object} from "prop-types";
import {Icon} from "features/components/icon";

export class TextField extends Component {

    state = {
        internal_error: null
    }

    doValidate() {
        const {validationFunc, value} = this.props;
        if (validationFunc && value)
            this.setState({internal_error: validationFunc(value)});
    }
    doChange(val) {
        const {onChange} = this.props;
        this.setState({internal_error: null});
        onChange(val);
    }

    render() {
        const {type, value, disabled, placeholder, hint, error, backgroundWhite, className, icon, refValue} = this.props;
        const {internal_error} = this.state;
        const hasValue = value && value !== "";
        const isInError = (error && error !== "") || internal_error;
        const hasBackgroundWhite = backgroundWhite || false;
        const isDisabled = disabled || false;
        const hasIcon = !!icon;
        return <div className={`text-field ${isInError ? "in-error" : ""} ${hasBackgroundWhite ? "background-white" : ""} ${isDisabled ? "disabled" : ""} ${className || ""}`}>
            <div className={`input-box ${hasValue ? "has-value" : ""} ${hasIcon ? "has-icon" : ""}`}>
                {hasIcon && <Icon>{icon}</Icon>}
                <input className={"input"}
                       type={type}
                       value={value}
                       onChange={(ev) => this.doChange(ev.target.value)}
                       onBlur={() => this.doValidate()}
                       disabled={disabled || false}
                       ref={refValue}
                />
                <span className={"placeholder"}>{placeholder}</span>
            </div>
            {
                (hint || isInError) && <div className={"hint"}>
                    <Icon>info-outline</Icon><p>{isInError ? error ?? internal_error : hint}</p>
                </div>
            }
        </div>;
    }
}

TextField.propTypes = {
    type: oneOf(["text", "password"]).isRequired,
    value: oneOfType([string, bool, number]).isRequired,
    placeholder: oneOfType([string, object]),
    error: oneOfType([string, object]),
    hint: oneOfType([string, object]),
    icon: string,
    onChange: func.isRequired,
    validationFunc: func,
    disabled: bool,
    backgroundWhite: bool,
    className: string,
    refValue: object
}